/* eslint-disable */
export default {
  contactDetails: 'Detalles de contacto',
  loadingContact: 'Cargando contacto...',
  contactNotFound: 'Contacto no encontrado.',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
